module.exports = __webpack_public_path__ + "static/media/javascript.94ae2dcd.png";